import { z } from 'zod';

import { type AgentSessionMessageMetadata } from '@air/server-sdk';

import { type WorkspaceAgentStructuredDisplay } from '~/components/v2/components/workspace/workspace-agent-panel/types/workspaceAgentStructuredDisplay';

const WorkspaceAgentStructuredDisplaySchema = z.object({
  description: z.string().min(1),
  icon: z.string().min(1),
  title: z.string().min(1),
  type: z.literal('structured'),
});

export const parseWorkspaceAgentStructuredDisplay = (
  metadata: AgentSessionMessageMetadata | null | undefined,
): WorkspaceAgentStructuredDisplay | null => {
  if (!metadata) {
    return null;
  }

  const parsed = WorkspaceAgentStructuredDisplaySchema.safeParse(metadata);

  if (!parsed.success) {
    return null;
  }

  const { description, icon, title } = parsed.data;

  return { description, icon, title };
};

export const getWorkspaceAgentUserMessageBubbleVariant = (
  metadata: AgentSessionMessageMetadata | null | undefined,
): 'user' | 'userHero' => (parseWorkspaceAgentStructuredDisplay(metadata) ? 'userHero' : 'user');
